/**
 * @generated SignedSource<<52d7aa8f724fe215529ac40d4cf02d98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiImageGenEditor_Query$variables = Record<PropertyKey, never>;
export type aiImageGenEditor_Query$data = {
  readonly imageGeneration: {
    readonly categoriesForEdit: ReadonlyArray<number>;
    readonly categoriesForGeneration: ReadonlyArray<number>;
    readonly id: string;
    readonly numberOfImagesEdit: number;
    readonly numberOfImagesGeneration: number;
    readonly showInImages: boolean;
    readonly showInUpload: boolean;
    readonly showInVerticalBar: boolean;
  } | null;
  readonly imageGenerationPresetCategories: ReadonlyArray<{
    readonly categoryID: number;
    readonly name: string;
  }>;
};
export type aiImageGenEditor_Query = {
  response: aiImageGenEditor_Query$data;
  variables: aiImageGenEditor_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageGenerationDTO",
    "kind": "LinkedField",
    "name": "imageGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfImagesGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfImagesEdit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoriesForGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoriesForEdit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showInUpload",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showInVerticalBar",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showInImages",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageGenerationPresetCategoryInfoDTO",
    "kind": "LinkedField",
    "name": "imageGenerationPresetCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiImageGenEditor_Query",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiImageGenEditor_Query",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "07b8d6d49fc6a479855ec90f050dd5d2",
    "id": null,
    "metadata": {},
    "name": "aiImageGenEditor_Query",
    "operationKind": "query",
    "text": "query aiImageGenEditor_Query {\n  imageGeneration {\n    id\n    numberOfImagesGeneration\n    numberOfImagesEdit\n    categoriesForGeneration\n    categoriesForEdit\n    showInUpload\n    showInVerticalBar\n    showInImages\n  }\n  imageGenerationPresetCategories {\n    categoryID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "8449210b945037ffa1bd2279f2d1c8e9";

export default node;
